'use client';

import React from 'react';
import useLocale from 'helpers/hooks/useLocale';
import { DataForPopularProduct } from 'types/next';
import { TasticProps } from '../types';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import ProductTileSlider from 'components/commercetools-ui/organisms/ProductTile-Slider';

const AlgoliaPopularProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();
  const fallbackLocale = 'en_GB';
  const searchQueryAttribute =
    data.data?.dataSource?.searchQuery?.[locale] || data.data?.dataSource?.searchQuery?.[fallbackLocale];
  const contentName = data?.contentName?.[locale] || data?.contentName?.[fallbackLocale] || data?.contentName;
  const shopAllLink = data?.shopallLink?.[locale] || data?.shopallLink?.[fallbackLocale] || data?.shopallLink;
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[] | undefined;

  return (
    <>
      <ProductTileSlider
        searchQueryAttribute={searchQueryAttribute}
        contentName={contentName}
        shopAllLink={shopAllLink}
        p1BadgeData={p1Badges}
        p2BadgeData={p2Badges}
      />
    </>
  );
};

export default AlgoliaPopularProductTastic;
